// extracted by mini-css-extract-plugin
module.exports = {"row":"Home_row__1de5_","col_C":"Home_col_C__3Ke0D","col":"Home_col__12nIu","card":"Home_card__cVRUz"};